module.exports = __webpack_public_path__ + "static/colazione200-f9694295411794b163e8b37e65a82906.png";